<script lang="ts" setup>
import { ref } from 'vue'
import { useUserStore } from '@/stores'
import { usePurchase } from '@/composables/usePurchase'

defineProps<{
  config: any
}>()

const user = useUserStore()
const { templateProducts, PayTemplate } = usePurchase('store')

const active = ref(0)
function paySubmit(item: any, index: number) {
  active.value = index
  PayTemplate(item)
}
</script>

<template>
  <div>
    <BasicNavbar class="color-n-text-2" />

    <!-- Cover -->
    <div class="pay-cover mt-44px mb-24px mx-10px b-rd-2">
      <div class="pt-18px px-26px">
        <p class="flex items-center space-x-5px">
          <span class="text-18px text-n-primary font-bold">{{ user.$state.coinBalance }}</span>
          <span class="relative text-12px text-n-text-2">coins</span>
        </p>
      </div>
      <div class="pay-template pt-2px pb-12px">
        <!-- 充值 -->
        <div
          v-for="(item, index) in templateProducts"
          :key="item.productId"
          class="pay-template-info flex items-center space-x-15px mt-10px mx-10px px-16px py-16px b-rd-2 bg-n-bg-card border border-color-#2C2B2D"
          :class="{ 'border-color-#FF6B6B': active === index }"
          @click="paySubmit(item, index)"
        >
          <div>
            <img class="w-24px h-24px" :src="config.resources.goldCoinIcon">
          </div>
          <div class="flex-1">
            <div>
              <strong class="text-18px text-n-text-1">{{ item.coinsBuy }}</strong>
              <span class="ml-5px text-14px text-n-text-2">coins</span>
            </div>
            <div class="flex items-center">
              <span class="text-14px text-n-primary">+{{ item.coinsBonus }} coins</span>
              <i v-if="item.marketingText" class="inline-block ml-10px px-9px bg-pink b-rd-12px text-n-text-inverse text-10px font-not-italic">{{ item.marketingText }}</i>
            </div>
          </div>
          <div class="text-right">
            <strong class="text-18px text-n-text-1">$ {{ item.price }}</strong>
            <p v-if="item.cornerTip" class="text-12px text-n-text-2">
              +{{ parseFloat((item.coinsBonus / item.coinsBuy * 100).toFixed(2)) }}% coins
            </p>
          </div>
        </div>
      </div>
      <div class="pb-20px px-16px text-10px text-n-text-3">
        <p class="text-12px mt-6px">
          {{ config.texts.tips }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip1 }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip2 }}
        </p>
        <p class="mt-6px">
          {{ config.texts.tip3 }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pay-cover {
  min-height: calc(100vh - 68px);
}
</style>
